import { createDataReducer } from 'app/api/redux-jigsaw/userdata/utils/reducer-utils';
import {
  DELETE_BOOKMARK,
  GET_BOOKMARKS,
  SET_BOOKMARK,
} from 'app/api/redux-jigsaw/jigsaw-methods';

export default createDataReducer({
  get: GET_BOOKMARKS,
  add: SET_BOOKMARK,
  del: DELETE_BOOKMARK,
  itemName: 'bookmark',
  listName: 'bookmarks',
});



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/userdata/bookmarks/reducer.js